import { AvailabilityActionType } from '../contants/actions-type'
import { privetData, handleErrorAndDispatch } from '../requests'

export const setAvailability = (requiredData) => async (dispatch) => {
  let request = await privetData()
  const response = await request
    .get('/host/space/availability')
    .catch((err) => {
      return err.response
    })

  handleErrorAndDispatch(requiredData, response, dispatch, {
    type: AvailabilityActionType.SET_AVAILABILITY,
    payload: {},
  })
}

export const selectAvailability = (requiredData) => async (dispatch) => {
  let request = await privetData()
  const response = await request
    .get(`/host/space/availability/${requiredData.id}/`)
    .catch((err) => {
      return err.response
    })
  handleErrorAndDispatch(requiredData, response, dispatch, {
    type: AvailabilityActionType.SELECT_AVAILABILITY,
    payload: {},
  })
}

export const createAvailability = (requiredData) => async (dispatch) => {
  let request = await privetData()
  const response = await request
    .post('/host/space/availability', requiredData)
    .catch((err) => {
      return err.response
    })
  handleErrorAndDispatch(requiredData, response, dispatch, {
    type: AvailabilityActionType.CREATE_AVAILABILITY,
    payload: {},
  })
}

export const updateAvailability = (requiredData) => async (dispatch) => {
  let request = await privetData()
  const response = await request
    .patch(`/host/space/availability/${requiredData.id}/`, requiredData)
    .catch((err) => {
      return err.response
    })

  handleErrorAndDispatch(requiredData, response, dispatch, {
    type: AvailabilityActionType.UPDATE_AVAILABILITY,
    payload: {},
  })
}

export const updateAvailabilityDay = (requiredData) => async (dispatch) => {
  let request = await privetData()
  const response = await request
    .patch(`/host/space/availability/day/${requiredData.id}/`, requiredData)
    .catch((err) => {
      return err.response
    })

  handleErrorAndDispatch(requiredData, response, dispatch, {
    type: AvailabilityActionType.UPDATE_AVAILABILITY,
    payload: {},
  })
}

export const deleteAvailability = (requiredData) => async (dispatch) => {
  let request = await privetData()
  const response = await request
    .delete(`/host/space/availability/${requiredData.id}/`, requiredData)
    .catch((err) => {
      return err.response
    })

  handleErrorAndDispatch(requiredData, response, dispatch, {
    type: AvailabilityActionType.REMOVE_AVAILABILITY,
    // payload:response.data
  })
}
